// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._27zgY{margin-top:0.25rem;margin-bottom:0.5rem;color:#ff6000 !important;text-transform:uppercase}._2GB_9{color:#000 !important}\n", "",{"version":3,"sources":["webpack://./src/views/Packages/ToField/List.scss"],"names":[],"mappings":"AAEA,QACC,kBAAmB,CACnB,oBAAqB,CAErB,wBAA0B,CAC1B,wBAAyB,CACzB,QAGA,qBAA0B","sourcesContent":["@import \"../../../scss/variables\";\n\n.region {\n\tmargin-top: 0.25rem;\n\tmargin-bottom: 0.5rem;\n\n\tcolor: $swg-sun !important;\n\ttext-transform: uppercase;\n}\n\n.vwq {\n\tcolor: $blk-100 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"region": "_27zgY",
	"vwq": "_2GB_9"
};
export default ___CSS_LOADER_EXPORT___;
